import { Serializer } from '../common';
import { aswServiceInitialState } from './asw-service.reducer';
import { AswServiceState } from './asw-service.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const aswServiceStorageDeserializer = (rawObject: any) => {
  return {
    ...aswServiceInitialState,
    ...rawObject,
  } as AswServiceState;
};

export const aswServiceStorageSync: Serializer<AswServiceState> = {
  deserialize: aswServiceStorageDeserializer,
};
